import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-device14",
  "use": "icon-device14-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-device14\"><path d=\"M895.89 160l0.11 0.11v575.78l-0.11 0.11H128.11l-0.11-0.11V160.11l0.11-0.11h767.78m0.11-64H128a64.19 64.19 0 0 0-64 64v576a64.19 64.19 0 0 0 64 64h768a64.19 64.19 0 0 0 64-64V160a64.19 64.19 0 0 0-64-64zM832 864H192v64h640v-64z\" p-id=\"5444\" /><path d=\"M576 736H448v128h128V736zM128 672h768v64H128zM512 256a160 160 0 1 1-113.14 46.86A159 159 0 0 1 512 256m0-64c-123.71 0-224 100.29-224 224s100.29 224 224 224 224-100.29 224-224-100.29-224-224-224z\" p-id=\"5445\" /><path d=\"M544 384h-64v160h64V384zM544 288h-64v64h64v-64z\" p-id=\"5446\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/icon-device14.svg
// module id = lhy/
// module chunks = 120